import discussion from './modules/discussion'
import information from './modules/information'
import notification from './modules/notification'

export default {
  namespaced: true,
  modules: {
    information,
    discussion,
    notification,
  },
}
